<template>
  <field
    :empty="isEmpty && !forceLabelToTop && !placeholder"
    v-bind="$attrs"
    :label="label"
    :icon="icon"
  >
    <template #label>
      <slot name="label">
        {{ label }}
      </slot>
    </template>
    <textarea
      v-model="value"
      :placeholder="placeholder"
      :aria-label="label"
      v-bind="{ ...$attrs, class: '' }"
    />
    <template v-if="$slots.icon" #icon>
      <slot name="icon" />
    </template>
  </field>
</template>

<script lang="ts" setup>
import { computed, type FunctionalComponent } from 'vue';
import { useVModel, type VueInstance } from '@vueuse/core';
import Field from '@components/utils/inputs/Field.vue';

interface Props {
  modelValue?: string | number;
  label?: string;
  placeholder?: string;
  icon?: VueInstance | FunctionalComponent | string | object;
  forceLabelToTop?: boolean;
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const value = useVModel(props, 'modelValue', emit, { passive: true });

const isEmpty = computed(() => {
  const currentValue = value.value;
  if (typeof currentValue === 'number') return !currentValue && currentValue !== 0;
  return !currentValue;
});
</script>
<style lang="scss" scoped>
textarea {
  &:disabled {
    @apply border-light-gray;
    @apply bg-table-head-gray;
  }
  background-color: var(--input-bg, var(--color-background-light));
  padding: var(--input-padding, #{px(10)} #{px(14)});
  outline: 0;
  width: 100%;
  height: 7.5rem;
}
</style>
